'use strict';

angular.module('casist.ucto')
  .factory('UCTDennik', ['Restangular', '$q', 'BaseModel', 'BaseCollectionModel', 'Profile', function (Restangular, $q, BaseModel, BaseCollectionModel, Profile) {
    var ENDPOINT = "uctdennik";
    Restangular.extendModel(ENDPOINT, function(model) {
      angular.extend(model, BaseModel)
      return angular.extend(model, {
        validate: function() {
          return BaseModel.validate();
        }
      });
    });
    return angular.extend(BaseCollectionModel.object(ENDPOINT), {
      getPerms: function() {
        return Profile.get('perms').uctdennik;
      }
    });
  }]);
